var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({ref:"autocomplete",attrs:{"type":"text"},on:{"input":_vm.placeChanged},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }